import { useNavigate } from "react-router-dom";
import '../App.css'

function Callback() {
    let navigate = useNavigate();
    const callbackRoute = window.localStorage.getItem("callbackRoute") ?? "/"
    navigate(callbackRoute)

    return (
        <div className="Callback">
        </div>
    )
}

export default Callback;